import {getAuth} from 'firebase/auth';
import axios from 'axios';
import {doc, getDoc} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';

const API_URL = 'https://influxapi.smartchargecontroller.ch/v1/meterReport';

export const fetchMeterReport = async (edgeId, start, stop) => {
  const idTokenResult = await getAuth().currentUser.getIdTokenResult();
  const headers = {'Authorization': `Bearer ${idTokenResult.token}`};
  const response = await axios.post(API_URL, {id: edgeId, start, stop}, {headers});
  return response.data;
};

export const fetchEdgeAddress = async (edgeId) => {
  const edgeSnap = await getDoc(doc(db, 'edges', edgeId));
  if (edgeSnap.exists()) {
    return edgeSnap.data().address;
  }
  return '';
};
